import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import LanguageSelector from "@/components/LanguageSelector";
import { Skull, Flame } from "lucide-react";

export default function Login() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Capture referral code from URL if present
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      try { localStorage.setItem("pending_referral", ref.toUpperCase()); } catch (e) { /* noop */ }
    }
    api.me().then(() => navigate("/game")).catch(() => setChecking(false));
  }, [navigate]);

  const startLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/game";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#8c8c8c] font-heading tracking-widest">
        <span className="ember-pulse">{t("login.loading")}</span>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 relative transition-all
              duration-500
              hover:drop-shadow-[0_0_20px_rgba(122,123,122,0.8)]">
      {/* Language selector — top-right so players can switch before Google sign-in. */}
      <div className="absolute top-4 right-4">
        <LanguageSelector variant="compact" />
      </div>
      <div className="max-w-md w-full panel p-8 relative">
        <div className="absolute -top-3 left-6 px-3 bg-[#050505] text-[#8c8c8c] text-xs tracking-[0.3em] font-heading">
          THE THRESHOLD
        </div>
        <div className="flex flex-col items-center gap-4 pt-2">
          <div className="w-auto h-auto flex items-center justify-center relative">
            <img src="https://assets.grim-walker.com/img/logo%20autunno.png" alt="grimwalkerlogo"></img>
          </div>
          <p className="font-body italic text-[#8c8c8c] text-center text-sm leading-relaxed">
            {t("app.tagline")}
          </p>
          <div className="rune-div w-full" />
          <button
            data-testid="google-login-button"
            onClick={startLogin}
            className="w-full py-4 border-2 border-[#333] bg-[#0a0a0a] text-[#E2DFD8] font-heading uppercase tracking-[0.2em] text-sm hover:drop-shadow-bg-green-700 hover:scale-105"
          >
            {t("login.enter")}
          </button>
          <p className="text-[10px] text-[#666] tracking-[0.2em] uppercase mt-2">
            {t("login.signInHint")}
          </p>
        </div>
      </div>
      <div className="mt-8 font-body italic text-[#555] text-xs max-w-md text-center">
        &ldquo;{t("login.quote")}&rdquo;
      </div>
    </div>
  );
}
